module.exports = __webpack_public_path__ + "static/media/lds-logo_ru.d220c2b8.svg";